export default __webpack_public_path__ + "img/puroak-range-products.asset.7e4c4443.png";